import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import { TabView, TabPanel } from 'primereact/tabview';
import { Sidebar } from "primereact/sidebar";
import education from '../assets/images/education-1.png';
import security from '../assets/images/secure-1.png';
import extrovert from '../assets/images/extrovert-1.png';
import education2 from '../assets/images/education-2.png';
import security2 from '../assets/images/secure-2.png';
import extrovert2 from '../assets/images/extrovert-2.png';
import upwardarrow from '../assets/images/upward-arrow.png';
import engage2 from '../assets/images/engage2.png';
import engage1 from '../assets/images/engage1.png';
import staff_logo from '../assets/images/staff_logo1.png';
import k12logo from '../assets/images/k12logo1.png';
import downvector from '../assets/images/DownVector.svg';
import leader from '../assets/images/82-leader.svg';
import student1 from '../assets/images/student.svg';
import whiteLogoImg from '../assets/brands/Knox_County_Schools_White.png';
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "primereact/tooltip";
import Horizontalbarchart from "./Annualplandashboard/charts/horizontalbarchart";
import Horizontalbar from "./Annualplandashboard/charts/horizontalbar";
import TopLinesChart from "./Annualplandashboard/charts/toplineschart";
import DoubleLineChart from "./Annualplandashboard/charts/doublelinechart";
import Horizontalbar2 from "./Annualplandashboard/charts/horizontalbar2";
import StaffSideBar from "./Annualplandashboard/popups/staffsidebar";
import StaffBottomBar from "./Annualplandashboard/popups/staffbottombar";
import StaffBottomBar1 from "./Annualplandashboard/popups/staffbottombar1";
import StaffBottomBar2 from "./Annualplandashboard/popups/staffbottombar2";
import { fetchAbsentees, fetchAbsentees_Trend, fetchLongetivity_Milestone, fetchMajor_Absence_Reason, fetchRetention_Rate, fetchSchools_with_High_Absenteeism, fetchSchools_With_High_Absentees, fetchSchools_with_Least_Absenteeism, 
    fetchStaff_Absenteeism, fetchStaff_Absenteeism_Gender, fetchStaff_Demographic_Snapshot, fetchStaff_Diversity, fetchStaff_Engagement_Index, fetchStaff_Retention_Snapshot, fetchStudent_Teacher_Ratio, 
    fetchTeacher_NonTeacher_Ratio, fetchTop_Absence_Reason, fetchTotal_Staff, fetchTotal_Staff_Gender, fetchWhite_NonWhite } from "../redux/slices/staffdetails";
import TopNav from "../components/common/topnav.component";
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { Dialog } from "primereact/dialog";
import StaffAppliedFilters from "../components/filterComponent/StaffAppliedFilters";
import ValueTooltip from "../components/Tooltip/valueTooltip";
import HeadingTooltip from "../components/Tooltip/headingTooltip";


export default function Staffdetails() {
    const [isMenuSideBarVisible, setMenuSideBarVisible] = useState(false);
    const [visibleBottom, setVisibleBottom] = useState(false);
    const [visible1Bottom, setVisible1Bottom] = useState(false);
    const [visible2Bottom, setVisible2Bottom] = useState(false);
    const [selectedtitle, setSelectedtitle] = useState('');

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedtile, setSelectedtile] = useState({ title: "", value: {} });

    const [screenWidth, setScreenWidth] = useState(0);
    useEffect(() => {
        const handleResize = () => {
          if (typeof window !== 'undefined') {
            const screenWidth = window.innerWidth;
            setScreenWidth(screenWidth);
          }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    /* Redux States */
    const dispatch = useDispatch();
    const Staff_Engagement_Index = useSelector(state => state.staffdetails.Staff_Engagement_Index);
    const Staff_Engagement_IndexLoading = useSelector(state => state.staffdetails.Staff_Engagement_Indexloading);
    const Longetivity_Milestone = useSelector(state => state.staffdetails.Longetivity_Milestone);
    const Longetivity_Milestoneloading = useSelector(state => state.staffdetails.Longetivity_Milestoneloading);
    const Total_Staff = useSelector(state => state.staffdetails.Total_Staff);
    const Total_Staffloading = useSelector(state => state.staffdetails.Total_Staffloading);
    const Retention_Rate = useSelector(state => state.staffdetails.Retention_Rate);
    const Retention_Rateloading = useSelector(state => state.staffdetails.Retention_Rateloading);
    const Staff_Absenteeism = useSelector(state => state.staffdetails.Staff_Absenteeism);
    const Staff_Absenteeismloading = useSelector(state => state.staffdetails.Staff_Absenteeismloading);
    const Staff_Absenteeism_Gender = useSelector(state => state.staffdetails.Staff_Absenteeism_Gender);
    const Staff_Absenteeism_Genderloading = useSelector(state => state.staffdetails.Staff_Absenteeism_Genderloading);
    const Student_Teacher_Ratio = useSelector(state => state.staffdetails.Student_Teacher_Ratio);
    const Student_Teacher_Ratioloading = useSelector(state => state.staffdetails.Student_Teacher_Ratioloading);
    const Schools_with_High_Absenteeism = useSelector(state => state.staffdetails.Schools_with_High_Absenteeism);
    const Schools_with_High_Absenteeismloading = useSelector(state => state.staffdetails.Schools_with_High_Absenteeismloading);
    const Schools_with_Least_Absenteeism = useSelector(state => state.staffdetails.Schools_with_Least_Absenteeism);
    const Schools_with_Least_Absenteeismloading = useSelector(state => state.staffdetails.Schools_with_Least_Absenteeismloading);
    const Top_Absence_Reason = useSelector(state => state.staffdetails.Top_Absence_Reason);
    const Top_Absence_Reasonloading = useSelector(state => state.staffdetails.Top_Absence_Reasonloading);
    const Staff_Demographic_Snapshot = useSelector(state => state.staffdetails.Staff_Demographic_Snapshot);
    const Staff_Demographic_Snapshotloading = useSelector(state => state.staffdetails.Staff_Demographic_Snapshotloading);
    const Staff_Retention_Snapshot = useSelector(state => state.staffdetails.Staff_Retention_Snapshot);
    const Staff_Retention_Snapshotloading = useSelector(state => state.staffdetails.Staff_Retention_Snapshotloading);
    const Staff_Diversity = useSelector(state => state.staffdetails.Staff_Diversity);
    const Staff_Diversityloading = useSelector(state => state.staffdetails.Staff_Diversityloading);
    const Teacher_NonTeacher_Ratio = useSelector(state => state.staffdetails.Teacher_NonTeacher_Ratio);
    const Teacher_NonTeacher_Ratioloading = useSelector(state => state.staffdetails.Teacher_NonTeacher_Ratioloading);
    const White_NonWhite = useSelector(state => state.staffdetails.White_NonWhite);
    const White_NonWhiteloading = useSelector(state => state.staffdetails.White_NonWhiteloading);
    const Major_Absence_Reason = useSelector(state => state.staffdetails.Major_Absence_Reason);
    const Major_Absence_Reasonloading = useSelector(state => state.staffdetails.Major_Absence_Reasonloading);
    const Schools_With_High_Absentees = useSelector(state => state.staffdetails.Schools_With_High_Absentees);
    const Schools_With_High_Absenteesloading = useSelector(state => state.staffdetails.Schools_With_High_Absenteesloading);
    const Absentees = useSelector(state => state.staffdetails.Absentees);
    const Absenteesloading = useSelector(state => state.staffdetails.Absenteesloading);
    const Absentees_Trend = useSelector(state => state.staffdetails.Absentees_Trend);
    const Absentees_Trendloading = useSelector(state => state.staffdetails.Absentees_Trendloading);
    const Total_Staff_Gender = useSelector(state => state.staffdetails.Total_Staff_Gender);
    const Total_Staff_Genderloading = useSelector(state => state.staffdetails.Total_Staff_Genderloading);


    /* API Call */
    useEffect(() => {
        dispatch(fetchStaff_Engagement_Index({
          "elasticQueryName": "Staff Engagement Index",
          "filters": [],
          "dynamicColumns": [],
        }));
    
        dispatch(fetchLongetivity_Milestone({
          "elasticQueryName": "Longetivity Milestone",
          "filters": [{
            "columnName": "SCHOOL_YEAR",
            "columnValue": ["2027"], "excludeKeyword": false
          }],
          "dynamicColumns": [],
        }));
    
        dispatch(fetchTotal_Staff({
          "elasticQueryName": "Total Staff",
          "filters": [{
            "columnName": "SCHOOL_YEAR",
            "columnValue": ["2027"], "excludeKeyword": false
          }],
          "dynamicColumns": [],
        }));
    
        dispatch(fetchRetention_Rate({
          "elasticQueryName": "Retention Rate",
          "filters": [{
            "columnName": "SCHOOL_YEAR",
            "columnValue": ["2027"], "excludeKeyword": false
          }],
          "dynamicColumns": [],
        }));

        dispatch(fetchStaff_Absenteeism({
          "elasticQueryName": "Staff Absenteeism",
          "filters": [{
            "columnName": "SCHOOL_YEAR",
            "columnValue": ["2027"], "excludeKeyword": false
          }],
          "dynamicColumns": [],
        }));

        dispatch(fetchStaff_Absenteeism_Gender({
          "elasticQueryName": "Staff_Absenteeism_Gender",
          "filters": [{
            "columnName": "SCHOOL_YEAR",
            "columnValue": ["2027"], "excludeKeyword": false
          }],
          "dynamicColumns": [],
        }));

        dispatch(fetchStudent_Teacher_Ratio({
            "elasticQueryName": "Student_Teacher_Ratio",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_with_High_Absenteeism({
            "elasticQueryName": "Schools with High Absenteeism",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_with_Least_Absenteeism({
            "elasticQueryName": "Schools with Least Absenteeism",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchTop_Absence_Reason({
            "elasticQueryName": "Top Absence Reason",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchStaff_Demographic_Snapshot({
            "elasticQueryName": "Staff Demographic Snapshot",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchStaff_Retention_Snapshot({
            "elasticQueryName": "Staff Retention Snapshot",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchStaff_Diversity({
            "elasticQueryName": "Staff Diversity",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchTeacher_NonTeacher_Ratio({
            "elasticQueryName": "Teacher /Non-Teacher Ratio",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchWhite_NonWhite({
            "elasticQueryName": "White/Non-White",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchMajor_Absence_Reason({
            "elasticQueryName": "Major Absence Reason",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_With_High_Absentees({
            "elasticQueryName": "Schools With High Absentees",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchAbsentees({
            "elasticQueryName": "Absentees",
            "filters": [
                {"columnName": "SCHOOL_YEAR", "columnValue": ["2027"], "excludeKeyword": false},            
            ],
            "dynamicColumns": [],
        }));

        dispatch(fetchAbsentees_Trend({
            "elasticQueryName": "Absentees_Trend",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchTotal_Staff_Gender({
            "elasticQueryName": "Total_Staff_Gender",
            "filters": [{
              "columnName": "SCHOOL_YEAR",
              "columnValue": ["2027"], "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
      }, [])

      const rtecontract = {
        height: '20px',
        tooltip: {
            show: false,
        },
        grid: {
          left: "7%",
          right: "7%",
          top: "-10%",
        //   containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
          axisLabel: {
            show: true,
          }
        },
       
        yAxis: [
          {
            type: "category",
            data: ["FTE / contract"],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            
            axisLabel: {
                show: false,
                color: "#828A91",
                fontSize: 14,
                inside: "true",
                marginTop: '20',
                // position: "top",
                // padding: [0, 15, 0, 0],
                // top: '10',
              },
              z: 10
          },
          {
            type: "category",
            data: ["98%"],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
                show: false,
                color: "#2C363F",
                fontSize: 14,
                fontWeight: 600,
                inside: "false",
                left: "0%",
                top: "5%",
                position: "left",
              },
            z: 10
          },
        ],
        series: [
          {
            type: "bar",
            stack: "total",
            barWidth: "5px",
            itemStyle: {
              normal: {
                barBorderRadius: [30, 0, 0, 30],
                color: "#768FB5",
              },
            },
            label: {
              show: false,
              position: 'topleft'
            },
            emphasis: {
              focus: "series",
            },
            data: [75],
          },
          {
            type: "bar",
            stack: "total",
            itemStyle: {
              normal: {
                barBorderRadius: [0, 30, 30, 0],
                color: "#ECECEC",
              },
            },
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: [25],
          },
        ],
      };

    const teacher = useMemo(() => {
        const category = ["Non-White", "White"];
        const grouped = Object.groupBy(
            White_NonWhite,
            ({ METRIC_NAME }) => METRIC_NAME
        );

        const result = {};

        for (const metric in grouped) {
            const valueMap = {};
            const percentMap = {};

            grouped[metric].forEach(item => {
                const { STUDENT_ETHNICITY, VALUE1, PERCENTAGE } = item;
                valueMap[STUDENT_ETHNICITY] = VALUE1;
                percentMap[STUDENT_ETHNICITY] = Number(PERCENTAGE.toFixed(1));
            });

            result[metric] = category.map(
                eth => valueMap[eth] ?? 0
            );

            result[`${metric}_Percentage`] = category.map(
                eth => percentMap[eth] ?? 0
            );
        }

        return result;
    }, [White_NonWhite]);

      const teacherdata = {
        height: "80px",
        tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
                type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },  
            backgroundColor: 'rgba(255, 255, 255)',
            borderColor: 'rgba(255,255,255,0.3)',
            borderWidth: 1,
            textStyle: {
                color: '#000',
                fontWeight: 500,
                fontSize: 14,
            },
            extraCssText: `
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                border-radius: 6px;
                padding: 8px 12px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            `,
            appendToBody: true, 
            // confine: true,
            formatter: (params) => {
                // row index: 0 = Non White, 1 = White
                const rowIndex = params[0].dataIndex;

                const ethnicity = ["Non White", "White"][rowIndex];

                const teacherValue = teacher["Staff Characteristics"]?.[rowIndex] ?? 0;
                const nonTeacherValue = teacher["Non-Teachers"]?.[rowIndex] ?? 0;

                const teacherPercent = teacher["Staff Characteristics_Percentage"][rowIndex] ?? 0;
                const nonTeacherPercent = teacher["Non-Teachers_Percentage"][rowIndex] ?? 0;

                return `
                <div style="font-size:12px">
                    Teacher – ${ethnicity}: ${teacherValue} (${teacherPercent}%)<br/>
                    Non Teacher – ${ethnicity}: ${nonTeacherValue} (${nonTeacherPercent}%)
                </div>`;
            },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "0px",
          bottom: "10px",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
          data: ["Non Teachers", "Teachers"],
          axisLabel: {
            position: "top",
            top: "5%",
          }
        },
       
        yAxis: [
          {
            type: "category",
            data: ["Non White", "White"],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#000",
            //   color: "#fff",
              fontSize: 10,
              inside: "true",
              left: "20%",
              position: "center",
              padding: 30,
            },
            z: 10,
          },
          {
            type: "category",
            data: (teacher['Non-Teachers'] ?? []).map(item => item ?? ''),
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#536580",
              inside: "true",
              fontSize: 14,
              fontWeight: 600,
            },
            z: 10,
          },
        ],
        series: [
          {
            name: "Teachers",
            type: "bar",
            stack: "total",
            barWidth: "25px",
            barGap: "0%",
            avoidLabelOverlap: true,
            showBackground: true,
            itemStyle: {
              normal: {
                barBorderRadius: [30, 30, 30, 30],
                color: "#34307A",
              },
            },
            label: {
              show: true,
              position: "center",
              color: "#fff",
              fontSize: 14,
              padding: 8,
            },
            emphasis: {
              focus: "series",
            },
            // data: [71, 68],
            // data: White_NonWhite?.filter(item => item?.METRIC_NAME != "Non-Teachers")?.map(item => item?.VALUE1),
            data: teacher['Staff Characteristics'] ?? [],
          },
        ],
      };
    /* popup Page data */
    const PopupData = [...Longetivity_Milestone, ...Retention_Rate, ...Total_Staff, ...Staff_Absenteeism]
    const HandleSelectTile = (title, value) => {
        setSelectedtile({ title: title, value: value })
    }
    /* */

    const Staff_Demographic_Snapshot_IMG = [education, security, extrovert]
    const Staff_Demographic_Snapshot_IMG2 = [education2, security2, extrovert2]
    const TotalStaffColors = ["#D62C72","#0066FF","#069564"]

    const Absentees_TrendData = Absentees_Trend.map(item => {
        const [month, day, year] = item.INCIDENT_TIME.split('/').map(Number);
        const date = new Date(year, month - 1, day);
        const dayPart = date.getDate(); // 1-31
        const monthPart = date.toLocaleString('en-US', { month: 'short' }); // Jan, Feb, etc.
        return {
          ...item,
          INCIDENT_TIME: `${dayPart} ${monthPart}`
        };
    });
    
    /* Total Staff Gender Bar */
    const Chart = ({data, label, color='blue'}) => {
        const options = {
        tooltip:{
            show: true,
            trigger: 'axis',
            confine: true,
            formatter: (params) => params?.[0]?.marker + params?.[0]?.axisValue + ': ' + params?.[0]?.value?.toFixed(1) +'%' 
        },
          grid: {
            top: -5,
            bottom: -5,
            left: -5,
            right: -5,
            containLabel: true
          },
          yAxis: {
            type: 'category',
            data: [label],
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            },
            max: 100,
            interval: 20
          },
          series: [
            {
              data: [data],
              type: 'bar',
              label: {
                show: false,
                position: "inside",
                distance: 0,
                color: "#fff",
                fontSize: 9,
                formatter: ({ value }) => value ? value.toFixed(1)+'%' : '-'
              },
              itemStyle: {
                color,
              }
            }
          ]
        }
        return (<ReactEcharts option={options} notMerge style={{width:'1.5rem', height: '1.5rem'}} className="inline-block mr-1" />)
    }
    /* */

    const AdministrativeStaff = Absentees?.filter(item => item?.PLACEMENT_TYPE == 'Administrative Staff');
    const CertifiedStaff = Absentees?.filter(item => item?.PLACEMENT_TYPE == 'Certified Staff');
    const SupportStaff = Absentees?.filter(item => item?.PLACEMENT_TYPE == 'Support Staff');

    /* Tooltip Description */
    const TooltipAttributes = ({ categorydescription }) => {
        return {
            'data-pr-tooltip': `${categorydescription}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            'data-pr-className': 'custom-tooltip !mt-[20px] !pt-0',
            style: { cursor: 'pointer' }
        }
    }
    /*  */

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    return(
        <>
            <div className="body staffbg">
                <TopNav pagename="Staff Details" pagenamedescription="Key facts about Staff" />
                <div className="px-[40px] pb-3 mb-3">
                    {/* <div className="flex justify-between pt-[10px]">
                        <div className="flex gap-[25px] items-center">
                            <Link to={"/"} className="">
                                <img src={whiteLogoImg} width={80} style={{ height: 80 }} alt='home icon' className="" />
                            </Link>
                            <div className="text-[16px] text-[#fff] font-medium ">Staff 360 / Insights</div>
                        </div>
                        <div className="pt-1">
                            <Link to={"/"} className="">
                            <img src={k12logo} alt='home icon' className="" />
                            </Link>
                        </div>
                    </div> */}
                    <div className="flex justify-between items-center mb-3">
                        <div className="text-[#fff] text-[18px]"><span className="font-semibold">Yesterday's Insights</span> - {Absentees?.[0]?.INCIDENT_TIME  ?? ''}</div>
                        <StaffAppliedFilters pagename={"Staff Details"}/>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <LoaderContainer loading={Absenteesloading} height={'100%'} width={'100%'}>
                            <div className="top-tile bg-[linear-gradient(to_right,#191112cc_0%,#2E0B0Dcc_100%)] p-4 rounded-[8px] cursor-pointer h-full" onClick={() => {setVisibleBottom(true); setSelectedtitle('Staff Absenteeism')}}>
                                <HeadingTooltip description="The total number of staff members who were absent during each day." formula="Count of distinct staff absences on the particular day.">
                                <div className="text-[18px] text-[#fff] font-semibold leading-[22px] mb-1 w-fit opacity-[80%]">Absentees</div>
                                </HeadingTooltip>
                                <div className="flex gap-[6px] items-center mb-2">
                                    <ValueTooltip heading={'Absentees'} value1={Absentees?.reduce((acc, {METRIC_NUMERATOR}) => (acc + METRIC_NUMERATOR) , 0)} value2={Absentees?.reduce((acc, {NUMERIC_COUNT}) => (acc + NUMERIC_COUNT) , 0)?.toFixed(2)+'%'}>
                                    <div className="text-[24px] 2xl:text-[30px] font-bold text-[#fff] leading-[34px] ">{Absentees?.reduce((acc, {METRIC_NUMERATOR}) => (acc + METRIC_NUMERATOR) , 0) || "-"}</div>
                                    </ValueTooltip>

                                    {Absentees?.[0]?.LAST_VARIANCE == 0 ?
                                    <div className="bg-[#F98080] rounded-[3px] text-[10px] font-medium text-[#fff] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; - % <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                    :
                                    Absentees?.[0]?.LAST_VARIANCE < 0 ?
                                    <div className="bg-[#F98080] rounded-[3px] text-[10px] font-medium text-[#fff] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; {Absentees?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                    :
                                    <div className="bg-[#069564] rounded-[3px] text-[10px] font-medium text-[#fff] px-2 py-1 flex gap-1.5 items-center ">LD Var &nbsp; {Absentees?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                    }
                                </div>
                                <div className="flex justify-between">
                                    <div className="">
                                        <div className="text-[12px] 2xl:text-[12px] font-medium text-[#D6D6D6] leading-[16px] pb-1.5 ">Administrative Staff</div>
                                        <div className="text-[18px] leading-[22px] text-[#fff] font-semibold " title={AdministrativeStaff?.[0]?.METRIC_NUMERATOR ? `Administrative Staff: ${AdministrativeStaff?.[0]?.METRIC_NUMERATOR} (${AdministrativeStaff?.[0]?.NUMERIC_COUNT?.toFixed(2)}%)` : '-'}>{AdministrativeStaff?.[0]?.METRIC_NUMERATOR || '-'}</div>
                                    </div>
                                    <div className="">
                                        <div className="text-[12px] 2xl:text-[12px] font-medium text-[#D6D6D6] leading-[16px] pb-1.5 ">Certified Staff</div>
                                        <div className="text-[18px] leading-[22px] text-[#fff] font-semibold " title={CertifiedStaff?.[0]?.METRIC_NUMERATOR ? `Certified Staff: ${CertifiedStaff?.[0]?.METRIC_NUMERATOR} (${CertifiedStaff?.[0]?.NUMERIC_COUNT?.toFixed(2)}%)` : '-'}>{CertifiedStaff?.[0]?.METRIC_NUMERATOR || '-'}</div>
                                    </div>
                                    <div className="">
                                        <div className="text-[12px] 2xl:text-[12px] font-medium text-[#D6D6D6] leading-[16px] pb-1.5 ">Support Staff</div>
                                        <div className="text-[18px] leading-[22px] text-[#fff] font-semibold " title={SupportStaff?.[0]?.METRIC_NUMERATOR ? `Support Staff: ${SupportStaff?.[0]?.METRIC_NUMERATOR} (${SupportStaff?.[0]?.NUMERIC_COUNT?.toFixed(2)}%)` : '-'}>{SupportStaff?.[0]?.METRIC_NUMERATOR || '-'}</div>
                                    </div>
                                </div>
                            </div>
                            </LoaderContainer>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <LoaderContainer loading={Major_Absence_Reasonloading} height={'100%'} width={'100%'}>
                            <div className="top-tile bg-[linear-gradient(to_right,#191112cc_0%,#2E0B0Dcc_100%)] p-4 rounded-[8px] cursor-pointer" onClick={() => {setVisible1Bottom(true); setSelectedtitle('Major Absence Reason')}}>
                                <HeadingTooltip description="The most frequently reported reason for staff absences." formula="Count of distinct staff absences for the reasons on the particular day. (Note: Medical and Misc Leave are excluded).">
                                <div className="text-[18px] text-[#fff] font-semibold leading-[22px] mb-3 capitalize w-fit opacity-[80%]">Major Absence Reason</div>
                                </HeadingTooltip>
                                <div className="h-[80px]">
                                    <Horizontalbar
                                        tooltip={{
                                            show: true,
                                            trigger: 'item',
                                            formatter: (params) => {
                                                return `${params?.marker} ${params?.name}: ${params?.data?.METRIC_NUMERATOR?.toFixed(0)} (${params?.data?.NUMERIC_COUNT?.toFixed(1)}%)`
                                            },
                                            confine: true
                                        }}
                                        grid={{
                                            top: '0%',
                                            left: '3%',
                                            right: '0%',
                                            bottom: '0%',
                                            containLabel: true,
                                        }}
                                        legend={{
                                        show: false,
                                        bottom: 0,
                                        padding:[0,0,0,20],
                                        left: 'start',
                                        itemGap: 4,
                                        itemWidth: 7,
                                        itemHeight: 7,
                                        textStyle: {
                                            color: '#828A91',
                                            fontSize: 7
                                            },
                                            data: [ 'Staff'],
                                        }}
                                        xAxis={{
                                            type: 'value',
                                            // min: 0,
                                            // max: 500,
                                            boundaryGap: [0, 0.01],
                                            splitLine: {
                                                show: false
                                            },
                                            axisLabel: {
                                                show: false
                                            }
                                        }}
                                        yAxis={{
                                            type: 'category',
                                            data: Major_Absence_Reason?.map(item => item?.MEASURE_TYPE.startsWith("Sick Bank  > ") ? item.MEASURE_TYPE.split("Sick Bank  > ")[1] : item.MEASURE_TYPE),
                                            // data: ['Family Illness', 'Personal Day', 'Personal Illness'],
                                            axisLabel: {
                                              show: true,
                                              color: '#ffffffcc',
                                              fontSize: 12,
                                            },
                                            axisLine: {
                                              show: false
                                            },
                                            axisTick: {
                                              show: false
                                            },
                                        }}
                                        name={'Staff'}
                                        type='bar'
                                        barWidth={'86%'}
                                        itemStyle={{
                                            color: '#A96534',
                                            barBorderRadius: [0, 4, 4, 0]
                                        }}
                                        data={Major_Absence_Reason?.map(item => {
                                            return {
                                                ...item, 
                                                value:item?.METRIC_NUMERATOR
                                            }
                                        })}
                                        label={{
                                            show: true,
                                            position: 'insideRight',
                                            color: '#fff', 
                                            fontSize: 14,
                                            fontWeight: 400,
                                            align: 'right'
                                        }}
                                    />
                                </div>
                            </div>
                            </LoaderContainer>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[linear-gradient(to_right,#191112cc_0%,#2E0B0Dcc_100%)] p-4 rounded-[8px] cursor-pointer" onClick={() => {setVisible1Bottom(true); setSelectedtitle('Schools With High Absentees')}}>
                                <HeadingTooltip description="Schools that report the highest number of staff absences." formula="Count of distinct staff absences for the schools on the particular day.">
                                <div className="text-[18px] text-[#fff] font-semibold leading-[22px] mb-3 capitalize w-fit opacity-[80%]">Schools With High Absentees</div>
                                </HeadingTooltip>
                                <div className="h-[80px]">
                                    <LoaderContainer loading={Schools_With_High_Absenteesloading} height={'100%'} width={'100%'}>
                                    <TopLinesChart 
                                        tooltip={{
                                            show: true,
                                            confine: true,
                                            formatter: (params) => {
                                                return `${params?.marker} ${params?.name}: ${params?.data?.METRIC_NUMERATOR?.toFixed(0)} (${params?.data?.NUMERIC_COUNT?.toFixed(1)}%)`
                                            },
                                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                            borderColor: 'rgba(255,255,255,0.3)',
                                            borderWidth: 1,
                                            textStyle: {
                                                color: '#fff',
                                                fontWeight: 500,
                                                fontSize: 13,
                                            },
                                            extraCssText: `
                                                backdrop-filter: blur(8px);
                                                -webkit-backdrop-filter: blur(8px);
                                                border-radius: 6px;
                                                padding: 8px 12px;
                                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                                            `,
                                        }}
                                        grid={{
                                            top: '5%',
                                            left: '8%',
                                            right: '0%',
                                            bottom: '25%',
                                            // containLabel: true,
                                          }}
                                        legend={{
                                            show:false,
                                            top: 'bottom',
                                            left: 'start',
                                            data: ['Shipping', 'Avg Per Month'],
                                            textStyle: {
                                              color: '#828A91',
                                              fontSize: 8
                                            }
                                        }}
                                        // xaxisdata={['School A', 'School B', 'School C', 'School D', 'School D']}
                                        xaxisdata={Schools_With_High_Absentees.map(item => item?.SCHOOL_OFFICIAL_NAME)}
                                        xaxisLabel={{
                                            color: '#ffffff99',
                                            formatter: function (value) {
                                                return value.length > 5 ? value.substring(0,5) + "..." : value;
                                            },
                                            fontSize: 10,
                                            interval: 0,
                                        }}
                                        xaxisLine={{show:false}}
                                        xaxisTick={{show:false}}
                                        
                                        // min={0}
                                        // max={40}
                                        interval={1}
                                        yaxisLabel={{
                                            color: '#ffffff99',
                                            fontSize: 10,
                                        }}
                                        yaxisLine={{
                                            lineStyle: {
                                                color: '#FFFFFF',
                                                type: 'dashed',
                                            },
                                        }}
                                        // data={[34, 23, 20, 18, 15]}
                                        data={Schools_With_High_Absentees.map(item => {
                                            return {
                                                ...item, 
                                                value:item?.METRIC_NUMERATOR
                                            }
                                        })}
                                        barWidth={'80%'}
                                        itemStyle={{
                                            color: '#A96534',
                                            borderRadius: [2, 2 ,0, 0],
                                        }}
                                        label={{
                                            show: false,
                                            position: 'insideTop',
                                            color: '#fff',
                                            fontSize: 14,
                                            fontWeight: 400,
                                            padding: [0, 0, 0, 0],
                                        }}
                                        Zoom={true}
                                    />
                                    </LoaderContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3">
                            <div className="top-tile bg-[linear-gradient(to_right,#191112cc_0%,#2E0B0Dcc_100%)] p-4 rounded-[8px] cursor-pointer" onClick={() => setVisible2Bottom(true)}>
                                <HeadingTooltip description="A weekly trend showing staff absences over the last 7 days." formula="Count of distinct staff absences for the last 7 working days.">
                                <div className="text-[18px] text-[#fff] font-semibold leading-[22px] mb-3 capitalize w-fit opacity-[80%]">Last 7 Days Absentees Trend</div>
                                </HeadingTooltip>
                                <div className="h-[80px]">
                                    <DoubleLineChart
                                        tooltip={{
                                            show: true,
                                            formatter: (params) => {
                                                return `${params?.marker} ${params?.name}: ${params?.data?.METRIC_NUMERATOR?.toFixed(0)} (${params?.data?.NUMERIC_COUNT?.toFixed(1)}%)`
                                            },
                                        }}
                                        data={Absentees_TrendData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content px-[40px] pb-[20px]">
                    <div className="grid grid-cols-12 gap-0.5 relative">
                        <div className="col-span-6">
                            <div className="block1 px-[15px] py-3 rounded-[12px]">
                                <div className="text-[16px] md:text-[18px] text-[#fff] font-semibold capitalize mb-2.5 ">Overall Insights - Staff Employment</div>
                                <div className="grid grid-cols-12 gap-3 mb-[1rem] w-full xl:w-[100%] ">
                                    <div className="col-span-12 lg:col-span-5 bg-[#251010] rounded-[6px] px-2 2xl:px-3 py-3 cursor-pointer" onClick={() => {HandleSelectTile("Total Staff", Total_Staff?.[0]); setMenuSideBarVisible(true)}}>
                                        <div className="flex justify-between items-center">
                                        <HeadingTooltip description="The total count of all active staff members in the district." formula="Count of distinct active staff members in the district.">
                                        <div className="text-[14px] 2xl:text-[16px] text-[#ffffffcc] leading-[16px] mb-[12px] font-semibold  w-fit">Total Staff</div>
                                        </HeadingTooltip>
                                        <div className="flex gap-[6px] items-center mb-[12px] flex-wrap forTotalStaff">
                                            <div className="text-[16px] xl:text-[20px] 2xl:text-[24px] font-bold text-[#fff] leading-[24px] ">{Total_Staff?.[0]?.CURRENT_YEAR}</div>
                                            {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 ">LY Var &nbsp; -% <img src={downvector} /></div> */}
                                                {Total_Staff?.[0]?.VARIANCE == 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-xs text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white'}}></i></div>
                                                    :
                                                    Total_Staff?.[0]?.VARIANCE < 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-xs text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap">LY Var &nbsp; {Total_Staff?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    <div className="bg-[#069564] rounded-[3px] !text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap">LY Var &nbsp; {Total_Staff?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                }
                                        </div>
                                        </div>
                                        <LoaderContainer loading={Total_Staffloading} height={"40px"} width={"100%"}>
                                        <div className="flex justify-between gap-1 2xl:gap-1">
                                            {Total_Staff_Gender.map((item,index) =>{ 
                                            return  <div key={index} className="">
                                                        <div className="text-[12px] 2xl:text-[12px] text-[#ffffffcc] leading-[14px] pb-1.5 w-auto break-words whitespace-normal min-h-[16px]">{item?.STUDENT_GENDER}</div>
                                                        <div className="text-[12px] 2xl:text-[18px] leading-[24px] 2xl:leading-[24px] text-[#fff] font-semibold flex gap-1 ">
                                                            <div className={`text-[10px] 2xl:text-[10px] text-[#fff] w-[25px] 2xl:w-[25px] text-center font-normal rounded-[3px]`} style={{backgroundColor: TotalStaffColors[index]}}>
                                                                {item?.VALUE}
                                                            </div>
                                                            {item?.CURRENT_YEAR?.toFixed(1)}%
                                                        </div>
                                                    </div>})
                                            }
                                            {/* <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Male</div>
                                                <div className="text-[12px] 2xl:text-[16px] leading-[20px] 2xl:leading-[24px] text-[#fff] font-semibold flex gap-1 "><div className="bg-[#2C82BE] text-[10px] 2xl:text-[12px] text-[#fff] w-[20px] 2xl:w-[30px] text-center font-normal ">51%</div>{MaleTotal_Staff?.[0]?.VALUE}</div>
                                            </div>
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Others</div>
                                                <div className="text-[12px] 2xl:text-[16px] leading-[20px] 2xl:leading-[24px] text-[#fff] font-semibold flex gap-1 "><div className="bg-[#11B87C] text-[10px] 2xl:text-[12px] text-[#fff] w-[20px] 2xl:w-[30px] text-center font-normal ">1%</div>{NonBinaryTotal_Staff?.[0]?.VALUE}</div>
                                            </div> */}
                                        </div>
                                        </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 md:col-span-6 lg:col-span-3 bg-[#251010] rounded-[6px] px-2 2xl:px-3 py-3 min-h-[142px] lg:min-h-[auto] ">
                                        <HeadingTooltip description="The representation of white vs non white groups among staff." formula="Count of distinct White Staff : Count of disinct non White Staff.">
                                        <div className="text-[14px] 2xl:text-[16px] text-[#ffffffcc] leading-[22px] mb-[12px] font-semibold  w-fit">Staff Diversity</div>
                                        </HeadingTooltip>
                                        <div className="flex justify-between">
                                            <div className="text-[12px] text-[#ffffffcc] leading-[14px] pb-1.5">
                                                <span className="block">KPS</span>
                                                <span className="block">Diversity</span>
                                            </div>

                                            <div className="text-[12px] text-[#ffffffcc] leading-[14px] pb-1.5 text-right">
                                                <span className="block">Statewide</span>
                                                <span className="block">Average</span>
                                            </div>
                                        </div>
                                        <LoaderContainer loading={Staff_Diversityloading} height={'20px'} width={'100%'}>
                                            <div className="flex justify-between items-center">
                                                <div className="text-[14px] 2xl:text-[18px] leading-[22px] font-semibold text-[#fff] flex ">{Staff_Diversity?.[0]?.VALUE}
                                                {Staff_Diversity?.[0]?.LY_VALUE == 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[10px] lg:text-[8px] xl:text-[10px] text-[#fff] px-1 flex gap-1 items-center whitespace-nowrap ml-1">LY Value &nbsp; - <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                    :
                                                    Staff_Diversity?.[0]?.LY_VALUE < 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[10px] lg:text-[8px] xl:text-[10px] text-[#fff] px-1 flex gap-1 items-center whitespace-nowrap ml-1">LY Value &nbsp; {Staff_Diversity?.[0]?.LY_VALUE} <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                        :
                                                        <div className="bg-[#069564] rounded-[3px] text-[11px] lg:text-[8px] xl:text-[11px] text-[#fff] px-1 flex gap-1 items-center whitespace-nowrap ml-1">LY Value &nbsp; {Staff_Diversity?.[0]?.LY_VALUE} <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                }
                                                </div>
                                                <div className="text-[14px] 2xl:text-[18px] leading-[22px] font-semibold text-[#fff] ml-3">8:1</div>
                                            </div>
                                        </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-[#251010] rounded-[6px] px-2 2xl:px-3 py-3 ">
                                        <HeadingTooltip description="The average number of students assigned per teacher." formula="Count of distinct Students : Count of distinct Teachers (Based on Positions with descriptions as Teacher).">
                                        <div className="text-[14px] 2xl:text-[16px] text-[#ffffffcc] leading-[22px] font-semibold mb-[12px]  w-fit">Student Teacher Ratio</div>
                                        </HeadingTooltip>
                                        <div className="flex justify-between">
                                            <div className="text-[12px] 2xl:text-[12px] text-[#ffffffcc] leading-[14px] pb-1.5">KPS</div>
                                            <div className="text-[12px] 2xl:text-[12px] text-[#ffffffcc] leading-[14px] pb-1.5 text-right">Statewide</div>
                                        </div>
                                        <LoaderContainer loading={Student_Teacher_Ratioloading} height={'20px'} width={'100%'}>
                                            <div className="flex justify-between items-center">
                                                <div className="text-[14px] 2xl:text-[16px] leading-[24px] text-[#fff] flex">{Student_Teacher_Ratio?.[0]?.VALUE}
                                                {Student_Teacher_Ratio?.[0]?.LY_VALUE == 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[10px] lg:text-[8px] xl:text-[10px] text-[#fff] ml-1 px-2 py-1 flex whitespace-nowrap gap-1.5 items-center ">LY Value &nbsp; - <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                    :
                                                    Student_Teacher_Ratio?.[0]?.LY_VALUE < 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[10px] lg:text-[8px] xl:text-[10px] text-[#fff] ml-1 px-2 py-1 flex whitespace-nowrap gap-1.5 items-center ">LY Value &nbsp; {Student_Teacher_Ratio?.[0]?.LY_VALUE} <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                        :
                                                        <div className="bg-[#069564] rounded-[3px] text-[11px] lg:text-[8px] xl:text-[11px] text-[#fff] ml-1 px-1 flex whitespace-nowrap gap-1 items-center ">LY Value &nbsp; {Student_Teacher_Ratio?.[0]?.LY_VALUE} <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                }
                                                </div>
                                                <div className="text-[14px] 2xl:text-[16px] leading-[24px] text-[#fff] ml-2">16:1</div>

                                            </div>
                                        </LoaderContainer>
                                    </div>
                                    {/* OLD Design */}
                                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-[#0F0D0B] rounded-[6px] px-2 2xl:px-3 py-2 ">
                                        <div className="text-[14px] 2xl:text-[16px] text-[#D6D6D6] leading-[16px] mb-[14px]">Staff Diversity</div>
                                    <LoaderContainer loading={Staff_Diversityloading} height={'100px'} width={'100%'}>
                                        <div className="flex gap-[6px] items-center mb-[1rem]">
                                            <div className="text-[20px] 2xl:text-[28px] font-bold text-[#fff] leading-[36px] ">{Staff_Diversity?.[0]?.VALUE}</div>
                                            {Staff_Diversity?.[0]?.LY_VALUE == 0 ?
                                                <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; - <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                :
                                                Staff_Diversity?.[0]?.LY_VALUE < 0 ?
                                                <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; {Staff_Diversity?.[0]?.LY_VALUE} <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                :
                                                <div className="bg-[#129C83] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; {Staff_Diversity?.[0]?.LY_VALUE} <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                            } 
                                        </div>
                                        <div className="flex gap-2 2xl:gap-4">
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Statewide Average</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">89:11</div>
                                            </div>
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">LY Value</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">-</div>
                                            </div>
                                        </div>
                                    </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-[#0F0D0B] rounded-[6px] px-2 2xl:px-3 py-2 ">
                                        <div className="text-[14px] 2xl:text-[16px] text-[#D6D6D6] leading-[16px] mb-[14px]">Student Teacher Ratio</div>
                                    <LoaderContainer loading={Student_Teacher_Ratioloading} height={'70%'} width={'100%'}>
                                        <div className="flex gap-[6px] items-center mb-[1rem]">
                                            <div className="text-[20px] 2xl:text-[28px] font-bold text-[#fff] leading-[36px] ">{Student_Teacher_Ratio?.[0]?.VALUE}</div>
                                            {Student_Teacher_Ratio?.[0]?.LY_VALUE == 0 ?
                                                    <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; - <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    Student_Teacher_Ratio?.[0]?.LY_VALUE < 0 ?
                                                    <div className="bg-[#db685b] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; {Student_Teacher_Ratio?.[0]?.LY_VALUE} <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    <div className="bg-[#129C83] rounded-[25px] text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Value &nbsp; {Student_Teacher_Ratio?.[0]?.LY_VALUE} <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                            } 
                                        </div>
                                        <div className="flex gap-2 2xl:gap-4">
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Statewide Average</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">16:1</div>
                                            </div>
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">LY Value</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">-</div>
                                            </div>
                                        </div>
                                    </LoaderContainer>
                                    </div> */}
                                </div>
                                <div className="text-[#D6D6D6] text-[18px] font-semibold leading-[20px] mb-4 ">Staff Demographic Snapshot</div>
                                <div className="flex gap-[10px] w-[100%] lg:w-[85%] mb-[20px] lg:mb-[20px] flex-wrap xl:flex-nowrap ">
                                {/* <div className="grid grid-cols-3 w-full gap-1"> */}
                                    {Staff_Demographic_Snapshot?.map((item, index) =>{ 
                                    return (
                                    <div key={index} className="flex items-center gap-[5px] 2xl:gap-[10px] bg-[#251010] rounded-[8px] items-start p-3">
                                        <div className="bg-[#0000001a] rounded-[6px] ">
                                            <img src={Staff_Demographic_Snapshot_IMG[index]} alt="education" style={{minWidth: '40px'}}/>
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#ffffffcc] leading-[14px] whitespace-nowrap">{item?.PLACEMENT_TYPE}</div>
                                            <div className="text-[18px] 2xl:text-[18px] flex gap-2 items-center font-semibold text-[#fff] leading-[18px] 2xl:leading-[22px] ">{item?.VALUE}<div className="text-[14px] 2xl:text-[16px] leading-[14px] 2xl:leading-[20px] font-normal ">{item?.CURRENT_YEAR?.toFixed(1)}%</div></div>
                                            {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-1 py-1 flex gap-1 whitespace-nowrap ">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(1)}% <img src={downvector} /></div> */}
                                            {item?.LAST_VARIANCE == 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    item?.LAST_VARIANCE < 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    <div className="bg-[#069564] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                            }
                                        </div>
                                    </div>)})
                                    }
                                    {/* <div className="flex gap-[5px] 2xl:gap-[10px] items-start">
                                        <div className="bg-[#0000001a] p-[10px] 2xl:p-[10px] rounded-[6px] ">
                                            <img src={security} alt="education" />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px]">Certified Staff</div>
                                            <div className="text-[18px] 2xl:text-[24px] flex gap-2 items-center font-bold text-[#fff] leading-[18px] 2xl:leading-[24px] ">850<div className="text-[14px] 2xl:text-[20px] leading-[14px] 2xl:leading-[20px] font-normal ">30%</div></div>
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 ">LY Var &nbsp; -5.9% <img src={downvector} /></div>
                                        </div>
                                    </div>
                                    <div className="flex gap-[5px] 2xl:gap-[10px] items-start">
                                        <div className="bg-[#0000001a] p-[10px] 2xl:p-[10px] rounded-[6px] ">
                                            <img src={extrovert} alt="education" />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px]">Supported Staff</div>
                                            <div className="text-[18px] 2xl:text-[24px] flex gap-2 items-center font-bold text-[#fff] leading-[18px] 2xl:leading-[24px] ">1255<div className="text-[14px] 2xl:text-[20px] leading-[14px] 2xl:leading-[20px] font-normal ">60%</div></div>
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 ">LY Var &nbsp; -5.9% <img src={downvector} /></div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="trio_wrap center-cone1">
                                    <div className="label h-[100%] text-center">
                                        <p>Demographics</p>
                                    </div>
                                </div>
                                <div className="bg-[#fff] absolute py-[15px] core_info w-[270px] h-[270px] rounded-full items-center ">
                                    <div className="">
                                        <div className="flex flex-col items-center justify-center">
                                            <div className=""><img src={leader} /></div>
                                            <div className="">
                                                <div className="text-[12px] font-semibold text-[#313131]">Total Staff</div>
                                                <div className="text-[26px] text-[#2C4089] font-bold leading-[26px] ">{Total_Staff?.[0]?.CURRENT_YEAR}</div>
                                            </div>
                                        </div>
                                        {/* <div className="h-[35px] mt-2">
                                            <div className="flex justify-between px-[20px] leading-[18px]">
                                                <div className="text-[#828A91] text-[14px] ">FTE / Contract</div>
                                                <div className="text-[#2C363F] font-semibold text-[14px] ">98%</div>
                                            </div>
                                            <ReactEcharts option={rtecontract} style={{ width: '100%', height: '100%', margin: 'auto' }} />
                                        </div> */}
                                        <div className="bg-[#E6F6FF] py-1">
                                            <div className="flex justify-between px-[15px]">
                                                <div className="text-[#242526] text-[10px] ">Teachers</div>
                                                <div className="text-[#242526] text-[10px] ">Non Teachers</div>
                                            </div>
                                            <ReactEcharts option={teacherdata} style={{ width: '100%', height: '60px', margin: 'auto' }} />
                                        </div>
                                        <div className="pt-[4px] text-center">
                                            <div className="text-[14px] font-semibold text-[#014EBA] mb-1 ">Teacher to Non-Teacher <span className="font-semibold">Ratio</span></div>
                                            <div className="flex flex-wrap gap-y-1 mb-1 justify-center w-[60%] m-auto">
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                                <img src={student1} />
                                            </div>
                                            <div className="text-[18px] font-semibold text-[#014EBA] ">{Teacher_NonTeacher_Ratio?.[0]?.VALUE}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-6">
                            <div className="block2 px-[15px] py-3 rounded-[12px]">
                                <div className="text-[16px] md:text-[18px] text-[#fff] font-semibold capitalize mb-2.5 text-right ">Overall Insights - Staff Retention</div>
                                <div className="grid grid-cols-12 gap-4 mb-[1rem] w-full xl:w-[100%] ml-auto ">
                                    <div className="col-span-12 lg:col-span-6 bg-[#10251E] rounded-[8px] px-3 py-3 cursor-pointer" onClick={() => {HandleSelectTile("Staff Retention", Retention_Rate?.[0]); setMenuSideBarVisible(true)}}>
                                    <LoaderContainer loading={Retention_Rateloading} height={"100%"} width={"100%"}>
                                        <div className="flex gap-2 items-center w-full">
                                            <div className="">
                                                <img src={upwardarrow} alt="Upward Arrow" width={56} />
                                            </div>
                                            <div className="flex justify-between w-full">
                                                <div className="flex flex-col items-start">
                                                    <HeadingTooltip description="% of staff reaching 10 year milestone." formula="Count of active distinct Staff with DOJ before 2016.">
                                                        <div className="text-[14px] 2xl:text-[18px] text-[#fffc] leading-[22px] font-semibold mb-3.5  w-fit">10-Year Retention Rate</div>
                                                    </HeadingTooltip>
                                                    <ValueTooltip heading={'10-Year Retention Rate'} value1={Retention_Rate?.[0]?.CURRENT_YEAR?.toFixed(1) + '%'} value2={Retention_Rate?.[0]?.NUMERIC_COUNT}>
                                                    <div className="text-[16px] xl:text-[20px] 2xl:text-[24px] font-bold text-[#fff] leading-[24px] mb-1">{Retention_Rate?.[0]?.CURRENT_YEAR?.toFixed(1) || "-"}%</div>
                                                    </ValueTooltip>
                                                    <div className="">
                                                    {Retention_Rate?.[0]?.VARIANCE == 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[10px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        Retention_Rate?.[0]?.VARIANCE < 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[10px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Retention_Rate?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        <div className="bg-[#069564] rounded-[3px] text-[10px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Retention_Rate?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    }
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="text-[12px] 2xl:text-[14px] text-[#fffc] leading-[18px] pb-2 ">LY Value</div>
                                                    <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] font-bold">{Retention_Rate?.[0]?.LAST_YEAR ? Retention_Rate?.[0]?.LAST_YEAR?.toFixed(1) : '-'}%</div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Var &nbsp; {Retention_Rate?.[0]?.VARIANCE} <img src={downvector} /></div> */}
                                        {/* <div className="w-1/2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Target</div>
                                            <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">{Retention_Rate?.[0]?.TARGET || "-"}%</div>
                                        </div> */}
                                    </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 lg:col-span-6 bg-[#10251E] rounded-[8px] px-3 py-3 cursor-pointer" onClick={() => {HandleSelectTile("Staff Retention", Longetivity_Milestone?.[0]); setMenuSideBarVisible(true)}}>
                                    <LoaderContainer loading={Longetivity_Milestoneloading} height={"85px"} width={"100%"}>
                                        <div className="flex gap-2 items-center w-full">
                                            <div className="">
                                                <img src={upwardarrow} alt="Upward Arrow" width={56} />
                                            </div>
                                            <div className="flex justify-between w-full">
                                                <div className="flex flex-col items-start">
                                                    <HeadingTooltip description="% of staff staying in the district year over year." formula="Count of active distinct Staff in Current Year/ Count of active distinct staff in Last Year.">
                                                        <div className="text-[14px] 2xl:text-[18px] text-[#fffc] leading-[22px] font-semibold mb-1.5  w-fit">1-Year Retention Rate</div>
                                                    </HeadingTooltip>
                                                    <ValueTooltip heading={'1-Year Retention Rate'} value1={Longetivity_Milestone?.[0]?.CURRENT_YEAR?.toFixed(1)+'%'} value2={Longetivity_Milestone?.[0]?.NUMERIC_COUNT}>
                                                    <div className="text-[16px] xl:text-[20px] 2xl:text-[24px] font-bold text-[#fff] leading-[24px] mb-1">{Longetivity_Milestone?.[0]?.CURRENT_YEAR?.toFixed(1)}%</div>
                                                    </ValueTooltip>
                                                    <div className="">
                                                    {Longetivity_Milestone?.[0]?.VARIANCE == 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        Longetivity_Milestone?.[0]?.VARIANCE < 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Longetivity_Milestone?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                            <div className="bg-[#069564] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Longetivity_Milestone?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="text-[12px] 2xl:text-[14px] text-[#fffc] leading-[14px] pb-1.5 ">LY Value</div>
                                                    <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] font-bold">{Longetivity_Milestone?.[0]?.LAST_YEAR ? Longetivity_Milestone?.[0]?.LAST_YEAR?.toFixed(1) : "-"}%</div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[10px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 items-center ">LY Var &nbsp; {Longetivity_Milestone?.[0]?.VARIANCE} <img src={downvector} /></div> */}
                                        {/* <div className="w-1/2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Target</div>
                                            <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">{Longetivity_Milestone?.[0]?.TARGET || "-"}%</div>
                                        </div> */}
                                    </LoaderContainer>
                                    </div>
                                    {/*IF the third tile is needed then uncomment the below div and and change the lg:col-span-4 to all the three divs */}
                                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4 bg-[#0F0D0B] rounded-[6px] px-3 py-2 ">
                                        <div className="text-[13px] 2xl:text-[16px] text-[#D6D6D6] leading-[16px] mb-[14px]">Prof Learning Participation</div>
                                        <div className="flex gap-[6px] items-center mb-[1rem]">
                                            <div className="text-[20px] 2xl:text-[28px] font-bold text-[#fff] leading-[36px] ">5%</div>
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 ">LY Var &nbsp; -5.9% <img src={downvector} /></div>
                                        </div>
                                        <div className="flex gap-4">
                                            <div className="w-1/2">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Target</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">10%</div>
                                            </div>
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">LY Value</div>
                                                <div className="text-[16px] 2xl:text-[20px] leading-[24px] text-[#fff] ">8%</div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="text-[#fff] text-[18px] font-semibold leading-[22px] mb-4 text-right ">Staff Retention 1Y Snapshot</div>
                                <div className="flex gap-[10px] justify-end w-[100%] lg:w-[85%] mb-[20px] lg:mb-[20px] ml-auto flex-wrap xl:flex-nowrap ">
                                {Staff_Retention_Snapshot.map((item,index) => {
                                    return(
                                    <div key={index} className="flex gap-[5px] 2xl:gap-[10px] bg-[#10251E] rounded-[8px] items-center p-3">
                                        <div className="bg-[#0000001a] rounded-[6px] ">
                                            <img src={Staff_Demographic_Snapshot_IMG2[index]} alt="education" style={{minWidth: '40px'}}/>
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#fffc] leading-[14px] whitespace-nowrap">{item?.PLACEMENT_TYPE}</div>
                                            <div className="text-[18px] 2xl:text-[18px] flex gap-2 items-center font-semibold text-[#fff] leading-[18px] 2xl:leading-[22px] ">{item?.VALUE} <div className="text-[14px] 2xl:text-[16px] leading-[14px] 2xl:leading-[20px] font-normal ">{item?.CURRENT_YEAR?.toFixed(1)}%</div></div>
                                            {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 whitespace-nowrap">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(1)}% <img src={downvector} /></div> */}
                                            {item?.LAST_VARIANCE == 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    item?.LAST_VARIANCE < 0 ?
                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    :
                                                    <div className="bg-[#069564] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {item?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                            }
                                        </div>
                                    </div>
                                    )})
                                }
                                    {/* <div className="flex gap-[5px] 2xl:gap-[10px] items-start">
                                        <div className="bg-[#0000001a] p-[10px] 2xl:p-[10px] rounded-[6px] ">
                                            <img src={security} alt="education" />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px]">Certified Staff</div>
                                            <div className="text-[18px] 2xl:text-[24px] flex gap-2 items-center font-bold text-[#fff] leading-[18px] 2xl:leading-[24px] ">30%</div>
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 ">LY Var &nbsp; -5.9% <img src={downvector} /></div>
                                        </div>
                                    </div>
                                    <div className="flex gap-[5px] 2xl:gap-[10px] items-start">
                                        <div className="bg-[#0000001a] p-[10px] 2xl:p-[10px] rounded-[6px] ">
                                            <img src={extrovert} alt="education" />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px]">Supported Staff</div>
                                            <div className="text-[18px] 2xl:text-[24px] flex gap-2 items-center font-bold text-[#fff] leading-[18px] 2xl:leading-[24px] ">35%</div>
                                            <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 ">LY Var &nbsp; -5.9% <img src={downvector} /></div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="trio_wrap center-cone2">
                                    <div className="label h-[100%] text-center">
                                        <p>Retention</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-6">
                            <div className="block3 px-[15px] py-3 rounded-[12px]">
                                <HeadingTooltip description="Schools with highest number of staff attendance." formula="Total Cumulative Attendance of the location in School Year/ Total Cumulative Attendance Days">
                                <div className="text-[16px] lg:text-[18px] w-fit text-[#fff] capitalize font-semibold mb-2">Locations with Highest Attendance</div>
                                </HeadingTooltip>
                                <div className="h-[120px] mb-[20px] w-[70%] lg:w-[80%] ">
                                    <Horizontalbar
                                        tooltip={{
                                            show: true,
                                            trigger: 'item',
                                            formatter: (params) => {
                                                return `${params?.marker} ${params?.name}: ${params?.data?.PERCENTAGE?.toFixed(2)}% (${params?.data?.NUMERIC_COUNT?.toFixed(0)})`
                                            },
                                            confine: true
                                        }}
                                        grid={{
                                            top: '0%',
                                            left: '0%',
                                            right: '15%',
                                            bottom: '0%',
                                            containLabel: true,
                                        }}
                                        legend={{
                                        show: false,
                                        bottom: 0,
                                        padding:[0,0,0,20],
                                        left: 'start',
                                        itemGap: 4,
                                        itemWidth: 7,
                                        itemHeight: 7,
                                        textStyle: {
                                            color: '#828A91',
                                            fontSize: 7
                                            },
                                            data: [ 'Staff'],
                                        }}
                                        xAxis={{
                                            type: 'value',
                                            // min: 0,
                                            // max: 90,
                                            // interval: 10,
                                            // boundaryGap: [0, 0.01],
                                            splitLine: {
                                                show: false
                                            },
                                            axisLabel: {
                                                show: true,
                                                color: '#D6D6D6',
                                                fontSize: 14,
                                            }
                                        }}
                                        yAxis={{
                                            type: 'category',
                                            // data: ['Longridge', 'Olympia', 'Odyssey Academy'],
                                            data: Schools_with_Least_Absenteeism?.map(item => item?.SCHOOL_OFFICIAL_NAME),
                                            axisLabel: {
                                              show: true,
                                              color: '#D6D6D6',
                                              fontSize: screenWidth < 1024 ? 12 : 14,
                                                // formatter: function (value) {
                                                //     // let maxLength = 20; 
                                                //     // if (screenWidth < 1024) {
                                                //     // maxLength = 10; 
                                                //     // } else {
                                                //     // maxLength = 25; 
                                                //     // }
                                                //     // return value.length > maxLength ? value.slice(0, maxLength) + "…" : value;
                                                //     return value.replace(" ", "\n");
                                                // }
                                                width: 150,
                                                overflow: 'break',
                                            },
                                            axisLine: {
                                              show: false
                                            },
                                            axisTick: {
                                              show: false
                                            },
                                        }}
                                        name={'Staff'}
                                        type='bar'
                                        barWidth={'86%'}
                                        itemStyle={{
                                            color: '#128D8D',
                                            barBorderRadius: [0, 4, 4, 0]
                                        }}
                                        showBackground={true}
                                        // data={[56, 57, 70]}
                                        data={Schools_with_Least_Absenteeism?.map(item => {
                                            return {
                                                ...item,
                                                value: item?.PERCENTAGE
                                            }
                                        })}
                                        label={{
                                            show: true,
                                            position: 'outside',
                                            color: '#fff', 
                                            fontSize: 14,
                                            fontWeight: 400,
                                            // align: 'right',
                                            formatter: (params) => params?.value > 0 ? params?.value?.toFixed(2)+'%' : ''
                                        }}
                                    />
                                </div>
                                <div className="text-[#fff] text-[18px] font-semibold leading-[18px] mb-3 ">Staff Attendance (YTD)</div>
                                <div className="grid grid-cols-12 gap-4 w-full xl:w-[100%] ">
                                    <div className="col-span-12 lg:col-span-5 bg-[#014B6E] rounded-[8px] px-3 py-3 cursor-pointer" onClick={() => {HandleSelectTile("Staff Absenteeism", Staff_Absenteeism?.[0]); setMenuSideBarVisible(true)}}>
                                        <div className="flex justify-between items-center mb-3">
                                            <HeadingTooltip description="Average staff absence rate for a school year." formula="Total Distinct Staff Absence Days (YTD) / Total Expected Staff Attendance Days (YTD)">
                                            <div className="text-[14px] 2xl:text-[18px] text-[#fffc] leading-[16px] font-semibold w-fit">Absentees</div>
                                            </HeadingTooltip>
                                            <div className="flex gap-[6px] items-center">
                                                <ValueTooltip heading="Absentees" value1={Staff_Absenteeism?.[0]?.CURRENT_YEAR?.toFixed(2)+'%'} value2={Staff_Absenteeism?.[0]?.NUMERIC_COUNT?.toFixed(0)}>
                                                <div className="text-[20px] 2xl:text-[26px] font-bold text-[#fff] leading-[36px] ">{Staff_Absenteeism?.[0]?.CURRENT_YEAR ? Staff_Absenteeism?.[0]?.CURRENT_YEAR?.toFixed(2) : '-'}%</div>
                                                </ValueTooltip>
                                                {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1 ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.VARIANCE} <img src={downvector} /></div> */}
                                                {Staff_Absenteeism?.[0]?.VARIANCE == 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        Staff_Absenteeism?.[0]?.VARIANCE < 0 ?
                                                        <div className="bg-[#069564] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                }
                                            </div>
                                        </div>
                                        <LoaderContainer loading={Staff_Absenteeism_Genderloading} height={'50px'}>
                                        <div className="flex justify-between gap-2.5">
                                            {Staff_Absenteeism_Gender?.map(((item, index) => {
                                            return(
                                            <div key={index} className="">
                                                <div className="text-[12px] 2xl:text-[12px] text-[#fffc] leading-[14px] pb-1.5 ">{item?.STUDENT_GENDER}</div>
                                                <div className="text-[12px] 2xl:text-[20px] leading-[24px] text-[#fff] font-bold flex gap-1 items-center " title={`${item?.STUDENT_GENDER}: ${item?.CURRENT_YEAR?.toFixed(2)}% (${item?.NUMERIC_COUNT?.toFixed(0)})`}>
                                                    {item?.CURRENT_YEAR?.toFixed(2)}%
                                                    {/* <div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] font-normal px-1 flex gap-1.5 ">{item?.VARIANCE} <img src={downvector} /></div> */}
                                                    {item?.VARIANCE == 0 ?
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">- <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        item?.VARIANCE < 0 ?
                                                        <div className="bg-[#069564] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">{item?.VARIANCE?.toFixed(1)}% <i className="pi pi-sort-down-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                        :
                                                        <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">{item?.VARIANCE?.toFixed(1)}% <i className="pi pi-sort-up-fill" style={{color: 'white', fontSize:'10px'}}></i></div>
                                                    }
                                                </div>
                                            </div>)
                                            }))
                                            }
                                            {/* <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Female</div>
                                                <div className="text-[12px] 2xl:text-[16px] leading-[20px] text-[#fff] font-semibold flex gap-1 items-center ">25%<div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] font-normal px-1 flex gap-1.5 ">-5.9% <img src={downvector} /></div></div>
                                            </div>
                                            <div className="">
                                                <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Others</div>
                                                <div className="text-[12px] 2xl:text-[16px] leading-[20px] text-[#fff] font-semibold flex gap-1 items-center ">21%<div className="bg-[#db685b] rounded-[25px] text-[10px] 2xl:text-[12px] text-[#EEEEF0] font-normal px-1 flex gap-1.5 ">-5.9% <img src={downvector} /></div></div>
                                            </div> */}
                                        </div>
                                        </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 lg:col-span-7 bg-[#014B6E] rounded-[8px] px-3 py-3 cursor-pointer" onClick={()=> setOpenDialog(true)}>
                                        <HeadingTooltip description="The most frequently reported reason for staff absences for a school year." formula="Total Absence Days for a Specific Reason (YTD) / Total Absence Days (YTD) × 100 (Note: Medical and Misc Leave are excluded)">
                                        <div className="text-[14px] 2xl:text-[18px] text-[#fffc] leading-[16px] font-semibold mb-[5px]  w-fit">Top Absence Reason</div>
                                        </HeadingTooltip>
                                        <LoaderContainer loading={Top_Absence_Reasonloading} height={'70%'} width={'100%'}>
                                        <div className="h-[75px] ">
                                            <Horizontalbar
                                                    tooltip={{
                                                        show: true,
                                                        trigger: 'item',
                                                        formatter: (params) => {
                                                            return `${params?.name}: ${params?.value?.toFixed(2)}% (${params?.data?.NUMERIC_COUNT?.toFixed(0)})`;
                                                        },
                                                        confine: true
                                                    }}
                                                grid={{
                                                    top: '0%',
                                                    left: '0%',
                                                    right: '0%',
                                                    bottom: '0%',
                                                    containLabel: true,
                                                }}
                                                legend={{
                                                show: false,
                                                bottom: 0,
                                                padding:[0,0,0,20],
                                                left: 'start',
                                                itemGap: 4,
                                                itemWidth: 7,
                                                itemHeight: 7,
                                                textStyle: {
                                                    color: '#828A91',
                                                    fontSize: 7
                                                    },
                                                    data: [ 'Staff'],
                                                }}
                                                xAxis={{
                                                    type: 'value',
                                                    // min: 0,
                                                    // max: 500,
                                                    boundaryGap: [0, 0.01],
                                                    splitLine: {
                                                        show: false
                                                    },
                                                    axisLabel: {
                                                        show: false
                                                    }
                                                }}
                                                yAxis={{
                                                    type: 'category',
                                                    // data: ['Family Illness', 'Personal Day', 'Personal Illness'],
                                                    data: Top_Absence_Reason
                                                    ?.slice(0,3)
                                                    ?.map(item => item?.MEASURE_TYPE.startsWith("Sick Bank  > ") ? item.MEASURE_TYPE.split("Sick Bank  > ")[1] : item.MEASURE_TYPE)?.reverse(),
                                                    axisLabel: {
                                                    show: true,
                                                    color: '#fffc',
                                                    fontSize: 12,
                                                    formatter: function (value) {
                                                        // let maxLength = 20; 
                                                        // if (screenWidth > 1024) {
                                                        // maxLength = 10; 
                                                        // } else {
                                                        // maxLength = 30; 
                                                        // }
                                                        // return value.length > maxLength ? value.slice(0, maxLength) + "…" : value;
                                                        return value.replace(" ", "\n");
                                                    }
                                                    },
                                                    axisLine: {
                                                    show: false
                                                    },
                                                    axisTick: {
                                                    show: false
                                                    },
                                                }}
                                                name={'Staff'}
                                                type='bar'
                                                barWidth={'86%'}
                                                itemStyle={{
                                                    color: '#1FA29B',
                                                    barBorderRadius: [0, 4, 4, 0]
                                                }}
                                                // data={[266, 292, 460]}
                                                data={Top_Absence_Reason
                                                    ?.slice(0,3)
                                                    ?.map(item => {
                                                        return {
                                                            ...item, 
                                                            value: item?.METRIC_NUMERATOR
                                                        }
                                                    })?.reverse()}
                                                label={{
                                                    show: true,
                                                    position: 'insideRight',
                                                    color: '#fff', 
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                    align: 'right',
                                                    formatter: (params) => params?.value > 0 ? params?.value?.toFixed(2)+'%' : ''
                                                }}
                                            />
                                        </div>
                                        </LoaderContainer>
                                    </div>
                                </div>
                                <div className="trio_wrap center-cone3">
                                    <div className="label h-[100%] text-center">
                                        <p>Attendance</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-6">
                            <div className="block4 flex flex-col justify-end items-end px-[15px] py-3 rounded-[12px]">
                                <HeadingTooltip description="Schools with lowest number of staff attendance." formula="Total Cumulative Attendance of the location in School Year/ Total Cumulative Attendance Days">
                                <div className="text-[16px] lg:text-[18px] text-[#fff] capitalize font-semibold mb-2 w-fit">Locations with Lowest Attendance</div>
                                </HeadingTooltip>
                                <div className="h-[120px] mb-[20px] w-[70%] lg:w-[80%] ml-auto ">
                                    <Horizontalbar
                                        tooltip={{
                                            show: true,
                                            trigger: 'item',
                                            formatter: (params) => {
                                                return `${params?.marker} ${params?.name}: ${params?.data?.PERCENTAGE?.toFixed(2)}% (${params?.data?.NUMERIC_COUNT?.toFixed(0)})`
                                            },
                                            confine: true
                                        }}
                                        grid={{
                                            top: '0%',
                                            left: '15%',
                                            right: '0%',
                                            bottom: '0%',
                                            containLabel: true,
                                        }}
                                        legend={{
                                        show: false,
                                        bottom: 0,
                                        padding:[0,0,0,20],
                                        left: 'start',
                                        itemGap: 4,
                                        itemWidth: 7,
                                        itemHeight: 7,
                                        textStyle: {
                                            color: '#828A91',
                                            fontSize: 7
                                            },
                                            data: [ 'Staff'],
                                        }}
                                        xAxis={{
                                            type: 'value',
                                            // min: 0,
                                            // max: 250,
                                            // interval: 25,
                                            // boundaryGap: [0, 0.01],
                                            inverse: true,
                                            splitLine: {
                                                show: false
                                            },
                                            axisLabel: {
                                                show: true,
                                                color: '#D6D6D6',
                                                fontSize: 14,
                                            }
                                        }}
                                        yAxis={{
                                            type: 'category',
                                            // data: ['Longridge', 'English Village', 'Greece Community ELC'],
                                            data: Schools_with_High_Absenteeism?.map(item => item?.SCHOOL_OFFICIAL_NAME),
                                            position: "right",
                                            axisLabel: {
                                              show: true,
                                              color: '#D6D6D6',
                                              fontSize: screenWidth < 1024 ? 12 : 14,
                                                formatter: function (value) {
                                                    // let maxLength = 20; 
                                                    // if (screenWidth < 1024) {
                                                    // maxLength = 10; 
                                                    // } else {
                                                    // maxLength = 30; 
                                                    // }
                                                    // return value.length > maxLength ? value.slice(0, maxLength) + "…" : value;
                                                    return value.replace(" ", "\n");
                                                }
                                            },
                                            axisLine: {
                                              show: false
                                            },
                                            axisTick: {
                                              show: false
                                            },
                                        }}
                                        name={'Staff'}
                                        type='bar'
                                        barWidth={'86%'}
                                        itemStyle={{
                                            color: '#4447C6',
                                            barBorderRadius: [0, 4, 4, 0]
                                        }}
                                        showBackground={true}
                                        // data={[178, 155, 194]}
                                        data={Schools_with_High_Absenteeism?.map(item => {
                                            return {
                                                ...item,
                                                value:item?.PERCENTAGE
                                            }
                                        })}
                                        label={{
                                            show: true,
                                            position: 'outside',
                                            color: '#fff', 
                                            fontSize: 14,
                                            fontWeight: 400,
                                            // align: 'left',
                                            formatter: (params) => params?.value > 0 ? params?.value?.toFixed(2)+'%' : ''
                                        }}
                                    />
                                </div>
                                {/* Hided */}
                                {/* <div className="text-[#fff] text-[18px] leading-[18px] font-semibold mb-3 text-right ">Staff Engagement Index<span className="text-[14px] 2xl:text-[16px]"> (District Level)</span></div> */}
                                {/* <div className="grid grid-cols-12 gap-4 w-full xl:w-[100%] ml-auto ">
                                    <div className="col-span-12 lg:col-span-6 bg-[#123376] rounded-[8px] px-3 py-3 min-h-[125px]">
                                        <LoaderContainer loading={Staff_Engagement_IndexLoading} height={"100%"} width={"100%"}>
                                            <div className="flex items-center gap-2 w-full">
                                                <div className="">
                                                    <img src={engage2} width={56} />
                                                </div>
                                                <div className="flex justify-between w-full">
                                                    <div className="flex flex-col items-start">
                                                        <div className="text-[14px] 2xl:text-[18px] text-[#fffc] leading-[22px] font-semibold mb-[8px]  w-fit">Mean</div>
                                                        <div className="text-[20px] 2xl:text-[26px] font-bold text-[#fff] leading-[36px] ">3.92</div>
                                                        {Staff_Engagement_Index?.[0]?.LAST_VARIANCE == 0 ?
                                                            <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                            :
                                                            Staff_Engagement_Index?.[0]?.LAST_VARIANCE < 0 ?
                                                                <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                                :
                                                                <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                        }
                                                    </div>
                                                    <div className="">
                                                        <div className="text-[12px] 2xl:text-[14px] text-[#fffc] leading-[14px] pb-1.5 ">LY Value</div>
                                                        <div className="text-[16px] 2xl:text-[20px] leading-[20px] 2xl:leading-[24px] font-bold text-[#fff] ">3.79</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </LoaderContainer>
                                    </div>
                                    <div className="col-span-12 lg:col-span-6 bg-[#123376] rounded-[8px] px-3 py-3 ">
                                        <LoaderContainer loading={Staff_Engagement_IndexLoading} height={"80px"} width={"100%"}>
                                            <div className="flex items-center gap-2 w-full">
                                                <div className="">
                                                    <img src={engage1} width={56} />
                                                </div>
                                                <div className="flex justify-between w-full">
                                                    <div className="flex justify-between w-full">
                                                        <div className="flex flex-col items-start">
                                                            <div className="text-[14px] 2xl:text-[18px] text-[#fffc] font-semibold leading-[22px] mb-[8px]  w-fit">Percentile</div>
                                                            <div className="text-[20px] 2xl:text-[24px] font-bold text-[#fff] leading-[24px] mb-1">41th</div>
                                                            {Staff_Engagement_Index?.[0]?.LAST_VARIANCE == 0 ?
                                                                <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                                :
                                                                Staff_Engagement_Index?.[0]?.LAST_VARIANCE < 0 ?
                                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                                    :
                                                                    <div className="bg-[#F98080] rounded-[3px] text-[11px] text-[#fff] px-2 py-1 flex gap-1.5 items-center whitespace-nowrap ">LY Var &nbsp; {Staff_Absenteeism?.[0]?.LAST_VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill" style={{ color: 'white', fontSize: '10px' }}></i></div>
                                                            }
                                                        </div>
                                                        <div className="">
                                                            <div className="text-[12px] 2xl:text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">LY Value</div>
                                                            <div className="text-[16px] 2xl:text-[20px] leading-[20px] 2xl:leading-[24px] text-[#fff] ">32nd</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </LoaderContainer>
                                    </div>
                                </div> */}
                                {/* End */}
                                <div className="trio_wrap center-cone4">
                                    <div className="label h-[100%] text-center">
                                        <p>Engagement Index</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-[#fff] absolute core_info"></div>
                    </div>
                </div>

                <Sidebar
                    visible={openDialog}
                    onHide={() => setOpenDialog(false)}
                    position="right"
                    className="custmSidebar 2xl:w-[18.75vw] bg-[#15181F]"
                    blockScroll={true}
                >
                    {/* <button onClick={() => setOpenDialog(false)} className={`absolute -top-[34px] right-[0px] px-[16px] py-[8px] rounded-t-[8px] flex items-center text-[#fff] gap-[8px] text-[14px] bg-[#272321] `}>
                        <i className='pi pi-times-circle'></i> Close
                    </button> */}
                    <div className="bg-[#014B6E] rounded-[8px] px-3 py-3 cursor-pointer h-full">
                        <div className="text-[24px] 2xl:text-[28px] text-[#fffc] leading-[16px] font-semibold mb-[5px]  w-fit">Top Absence Reason</div>
                        <LoaderContainer loading={Top_Absence_Reasonloading} height={'100%'} width={'100%'}>
                            <div className="h-full">
                                <Horizontalbar
                                    tooltip={{
                                        show: true,
                                        trigger: 'item',
                                        formatter: (params) => {
                                            return `${params?.name}: ${params?.value?.toFixed(2)}% (${params?.data?.NUMERIC_COUNT?.toFixed(0)})`;
                                        },
                                        confine: true
                                    }}
                                    grid={{
                                        top: '10%',
                                        left: '10%',
                                        right: '10%',
                                        bottom: '10%',
                                        containLabel: true,
                                    }}
                                    legend={{
                                        show: false,
                                        bottom: 0,
                                        padding: [0, 0, 0, 20],
                                        left: 'start',
                                        itemGap: 4,
                                        itemWidth: 7,
                                        itemHeight: 7,
                                        textStyle: {
                                            color: '#828A91',
                                            fontSize: 7
                                        },
                                        data: ['Staff'],
                                    }}
                                    xAxis={{
                                        type: 'value',
                                        // min: 0,
                                        // max: 500,
                                        boundaryGap: [0, 0.01],
                                        splitLine: {
                                            show: false
                                        },
                                        axisLabel: {
                                            show: false
                                        }
                                    }}
                                    yAxis={{
                                        type: 'category',
                                        // data: ['Family Illness', 'Personal Day', 'Personal Illness'],
                                        data: Top_Absence_Reason
                                            ?.map(item => item?.MEASURE_TYPE.startsWith("Sick Bank  > ") ? item.MEASURE_TYPE.split("Sick Bank  > ")[1] : item.MEASURE_TYPE)?.reverse(),
                                        axisLabel: {
                                            show: true,
                                            color: '#fffc',
                                            fontSize: 12,
                                            
                                        },
                                        axisLine: {
                                            show: false
                                        },
                                        axisTick: {
                                            show: false
                                        },
                                    }}
                                    name={'Staff'}
                                    type='bar'
                                    barWidth={'86%'}
                                    itemStyle={{
                                        color: '#1FA29B',
                                        barBorderRadius: [0, 4, 4, 0]
                                    }}
                                    // data={[266, 292, 460]}
                                    data={Top_Absence_Reason
                                        ?.map(item => {
                                            return {
                                                ...item,
                                                value: item?.METRIC_NUMERATOR
                                            }
                                        })?.reverse()}
                                    label={{
                                        show: true,
                                        position: 'right',
                                        color: '#fff',
                                        fontSize: 12,
                                        fontWeight: 400,
                                        align: 'right',
                                        padding: [0, -35, 0, 0],
                                        formatter: (params) => params?.value > 0 ? params?.value?.toFixed(2) + '%' : ''
                                    }}
                                />
                            </div>
                        </LoaderContainer>
                    </div>
                </Sidebar>

                <StaffSideBar
                    visible={isMenuSideBarVisible}
                    onHide={() => setMenuSideBarVisible(false)}
                    // setMenuSideBarpopup={setMenuSideBarVisible}
                    data={PopupData}
                    tile={[selectedtile, setSelectedtile]}
                />
                <StaffBottomBar 
                    visible={visibleBottom} 
                    onHide={() => setVisibleBottom(false)}
                    title={selectedtitle}
                    date={yesterday}
                />
                <StaffBottomBar1
                    visible={visible1Bottom} 
                    onHide={() => setVisible1Bottom(false)}
                    title={selectedtitle}
                    date={yesterday}
                />
                <StaffBottomBar2
                    visible={visible2Bottom} 
                    onHide={() => setVisible2Bottom(false)}
                    title={selectedtitle}
                    date={yesterday}
                />
                <div className="py-4 flex justify-end">
                    <div className="flex items-end">
                        <span className="text-white">Powered By </span>
                        <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                    </div>
                    </div>
            </div>
        </>
    )
}